module.exports = __webpack_public_path__ + "static/media/undraw_Personal_goals_re_iow7.abb0935e.png";